import { ICollapsedGroupsSetAction } from './types';
import { AT_COLLAPSED_GROUPS_SET } from './constants';
import { TCardId } from '../../../../../../types/types';

export const collapsedGroupsSetAction = (
    collapsedGroups: TCardId[]
): ICollapsedGroupsSetAction => ({
        type: AT_COLLAPSED_GROUPS_SET,
        collapsedGroups
    }
);
